var Z = Object.defineProperty;
var z = (s) => {
  throw TypeError(s);
};
var _ = (s, t, e) => t in s ? Z(s, t, { enumerable: !0, configurable: !0, writable: !0, value: e }) : s[t] = e;
var h = (s, t, e) => _(s, typeof t != "symbol" ? t + "" : t, e), L = (s, t, e) => t.has(s) || z("Cannot " + e);
var p = (s, t, e) => (L(s, t, "read from private field"), e ? e.call(s) : t.get(s)), b = (s, t, e) => t.has(s) ? z("Cannot add the same private member more than once") : t instanceof WeakSet ? t.add(s) : t.set(s, e), O = (s, t, e, n) => (L(s, t, "write to private field"), n ? n.call(s, e) : t.set(s, e), e), T = (s, t, e) => (L(s, t, "access private method"), e);
const w = class w extends Error {
  constructor(t, e) {
    super(w[t]), this.key = t, this.name = `${this.constructor.name}(${t})`, e instanceof Error && (this.message += `

${e.message}`, this.stack = e.stack);
  }
  is(t) {
    return this.key === t;
  }
};
// Global
h(w, "MEDIA_RECORDER_UNSUPPORTED", "MediaRecorder is not supported"), h(w, "AUDIO_CONTEXT_UNSUPPORTED", "AudioContext is not available"), h(w, "GETUSERMEDIA_UNSUPPORTED", "getUserMedia is not available"), // Recorder related
h(w, "RECORDER_NOT_INIT", "Recorder has not been initialized. Call init() method first"), h(w, "RECORDER_NO_RESULT", "Recorder produced no blob result"), // Encoder related
h(w, "ENCODER_SHINE_NOT_INIT", "Shine encoder has not been initialized"), h(w, "ENCODER_INVALID_INPUT_DATA", "Provided data is not a Float32Array"), h(w, "ENCODER_INVALID_RESULT", "Invalid encoder result. Output was not a blob");
let C = w;
function q(s) {
  return { all: s = s || /* @__PURE__ */ new Map(), on: function(t, e) {
    var n = s.get(t);
    n ? n.push(e) : s.set(t, [e]);
  }, off: function(t, e) {
    var n = s.get(t);
    n && (e ? n.splice(n.indexOf(e) >>> 0, 1) : s.set(t, []));
  }, emit: function(t, e) {
    var n = s.get(t);
    n && n.slice().map(function(a) {
      a(e);
    }), (n = s.get("*")) && n.slice().map(function(a) {
      a(t, e);
    });
  } };
}
class B extends Promise {
  constructor(e = () => {
  }) {
    var i;
    let n, a;
    super((r, o) => (n = r, a = o, e(r, o)));
    h(this, "resolve");
    h(this, "reject");
    h(this, "initialCallStack");
    h(this, "resolved", !1);
    this.resolve = (...r) => (this.resolved = !0, n(...r)), this.reject = a, this.initialCallStack = (i = new Error(" ").stack) == null ? void 0 : i.split(`
`).slice(2).join(`
`);
  }
  /** @throws error with amended call stack */
  rejectWithError(e) {
    var n;
    e.stack = [(n = e.stack) == null ? void 0 : n.split(`
`)[0], this.initialCallStack].join(`
`), this.reject(e);
  }
}
function tt() {
  return self;
}
function et() {
  let s = Promise.resolve();
  return {
    get promise() {
      return s;
    },
    run(t) {
      return s = s.then(t);
    }
  };
}
function J() {
  return q();
}
class E {
  static async get(t) {
    const e = navigator.mediaDevices || navigator || {}, n = e.getUserMedia || e.getUserMedia || e.webkitGetUserMedia || e.mozGetUserMedia || e.msGetUserMedia;
    if (!n)
      throw new C("GETUSERMEDIA_UNSUPPORTED");
    const a = await n.call(e, { audio: t || !0, video: !1 });
    return new MediaStream(a);
  }
  static getSettings(t) {
    return t.getAudioTracks()[0].getSettings();
  }
  static getCapabilities(t) {
    return t.getAudioTracks()[0].getCapabilities();
  }
  static isValid(t) {
    const e = t.getAudioTracks();
    return t.active && e.length > 0 && e.some((n) => n.enabled);
  }
  static dispose(t) {
    for (const e of t.getTracks())
      e.stop(), t.removeTrack(e);
    return t.dispatchEvent(new Event("dispose")), t.active;
  }
  /** Fires when `StreamUtil.dispose` is called on the given stream */
  static onDispose(t, e) {
    t.addEventListener("dispose", e);
  }
}
function j(s) {
  try {
    const t = tt();
    return new (t.AudioContext || t.webkitAudioContext)(s);
  } catch (t) {
    throw new C("AUDIO_CONTEXT_UNSUPPORTED", t);
  }
}
function nt(s) {
  try {
    return new OfflineAudioContext(s);
  } catch {
    return j(s);
  }
}
function st(s) {
  return s instanceof Blob && s.arrayBuffer ? s.arrayBuffer() : new Promise((t, e) => {
    const n = new FileReader();
    n.onload = () => t(n.result), n.onerror = e, n.readAsArrayBuffer(s);
  });
}
async function H(s, t = {
  numberOfChannels: 1,
  sampleRate: 48e3,
  length: 48e3
}) {
  const e = s instanceof Blob ? await st(s) : s.slice(0);
  return new Promise(
    (n, a) => nt(t).decodeAudioData(e, n, a)
  );
}
async function at(s) {
  const t = URL.createObjectURL(s);
  function e() {
    return new Promise((r, o) => {
      const u = new Audio();
      u.onerror = () => o(u.error), u.onloadedmetadata = () => r(u.duration), u.src = t;
    });
  }
  function n(r, o) {
    const u = o * 8 / 1e3;
    let d = Math.ceil(Math.round(u / r) / 16) * 16;
    return d = [48, 56, 64, 80, 96, 112, 128, 160, 192, 224, 256, 320].reduce((c, l) => Math.abs(l - d) < Math.abs(c - d) ? l : c), d;
  }
  const a = await e(), i = n(a, s.size);
  return URL.revokeObjectURL(t), { duration: a, bitRate: i };
}
function it({
  frequency: s = 440,
  rampValue: t = 1e-5,
  rampDuration: e = 1
} = {}) {
  const n = j({ latencyHint: "playback" }), a = n.currentTime, i = n.createOscillator(), r = n.createGain();
  return i.connect(r), r.connect(n.destination), r.gain.value = 0.4, r.gain.setValueAtTime(r.gain.value, a), r.gain.exponentialRampToValueAtTime(t, a + e), new Promise((o) => {
    i.onended = () => {
      r.disconnect(n.destination), i.disconnect(r), n.close(), o();
    }, i.type = "sine", i.frequency.value = s, i.start(a), i.stop(a + e);
  });
}
function rt(s, t) {
  const n = (s.length - 1) / (t - 1), a = [];
  for (let i = 0; i < t; i++) {
    const r = i * n, o = Math.floor(r), u = Math.ceil(r);
    if (o === u)
      a.push(s[o]);
    else {
      const d = r - o, f = s[o], c = s[u], l = f + (c - f) * d;
      a.push(l);
    }
  }
  return a;
}
function W(s, t, e) {
  const n = Math.min(...s), i = Math.max(...s) - n;
  return s.map((r) => i === 0 ? t + (e - t) / 2 : t + (r - n) / i * (e - t));
}
function F(s, t = 64) {
  t = Math.floor(t);
  const e = Math.floor(s.length / t), n = [];
  let a = 0;
  for (let o = 0; o < t; o++) {
    const u = e * o;
    for (let d = 0; d < e; d++)
      a += Math.abs(s[u + d]);
    n.push(a / e), a = 0;
  }
  const i = Math.max(...n);
  if (i <= 1e-4)
    return n;
  const r = i ** -1;
  return n.map((o) => o * r * 100);
}
function ot(s, t) {
  const e = t, n = Math.floor(s.length / e), a = [];
  for (let r = 0; r < e; r++) {
    const o = n * r;
    let u = 0;
    for (let d = 0; d < n; d++)
      u = u + Math.abs(s[o + d]);
    a.push(u / n);
  }
  const i = Math.max(...a) ** -1;
  return a.map((r) => r * i);
}
function ct(s, t) {
  return ot(s.getChannelData(0), t);
}
async function ut(s) {
  const t = await H(s);
  return {
    /** Duration in milliseconds */
    duration: t.duration * 1e3,
    peaks: ct(t, 100)
  };
}
class P extends Array {
  constructor(t, e = 100, n = 0, a = 100) {
    t || (t = []), e > t.length && (t = rt(t, e)), t = F(t, e), t = W(t, n, a), super(...t), this.samples = e, this.rangeMin = n, this.rangeMax = a;
  }
  clone(t = this.samples, e = this.rangeMin, n = this.rangeMax) {
    return new P(this, t, e, n);
  }
  getAverage(t = this.samples) {
    return F(this, t);
  }
  getToRange(t, e) {
    return W(this, t, e);
  }
  /** Returns array of numbers in given {@link digits} decimal places */
  toFixed(t) {
    return Array.from(this).map((e) => +e.toFixed(t));
  }
}
class V extends Number {
  constructor() {
    super(...arguments);
    h(this, "toJSON", () => this.valueOf());
  }
  get seconds() {
    return this.valueOf() / 1e3;
  }
  get minutes() {
    return this.seconds / 60;
  }
  get hours() {
    return this.seconds / 3600;
  }
}
class R extends Blob {
  constructor(e, n, a) {
    super([e], { type: e.type });
    /** Returns filename with proper extension of codec */
    h(this, "getFilename", (e) => `${e}.mp3`);
    this.blob = e, this.duration = n, this.peaks = a, Object.freeze(this);
  }
  toJSON() {
    return {
      blob: this.blob,
      duration: this.duration.valueOf(),
      peaks: Array.from(this.peaks)
    };
  }
  static fromJSON(e) {
    return new R(e.blob, new V(e.duration), new P(e.peaks));
  }
  /** Create AudioBlob from {@link Blob} or {@link ArrayBuffer} */
  static async parse(e) {
    const n = e instanceof Blob ? e : new Blob([e], { type: "audio/mpeg" }), { peaks: a, duration: i } = await ut(n);
    return new R(n, new V(i), new P(a));
  }
}
var M, N, Q;
const k = class k {
  constructor(t, e = new k.Config(t), n = k.createEmitter(
    new Worker(new URL(
      /* @vite-ignore */
      "./assets/worker-BJSQ0L5v.js",
      import.meta.url
    ), { name: "vocal-recorder/encoder", type: "module" })
  )) {
    b(this, N);
    h(this, "result", new B());
    h(this, "ready", new B());
    b(this, M, et());
    this.stream = t, this.config = e, this.worker = n, n.send(k.Event.INIT, e), n.on(k.Event.READY, this.ready.resolve), n.on(k.Event.RESULT, (a) => {
      this.result.resolve(R.parse(a));
    });
  }
  encode(t) {
    p(this, M).run(
      () => this.worker.send(k.Event.ENCODE, t, [t.buffer])
    );
  }
  async stop() {
    return await p(this, M).promise, this.worker.send(k.Event.STOP), this.result.finally(() => T(this, N, Q).call(this));
  }
};
M = new WeakMap(), N = new WeakSet(), Q = function() {
  this.worker.terminate();
};
let D = k;
((s) => {
  class t {
    constructor(a, i = E.getSettings(a), r = i.sampleRate || 48e3, o = 1, u = 128) {
      this.sampleRate = r, this.channels = o, this.bitRate = u;
    }
  }
  s.Config = t, ((n) => {
    n.INIT = "init", n.STOP = "stop", n.READY = "ready", n.ENCODE = "encode", n.RESULT = "result";
  })(s.Event || (s.Event = {}));
  function e(n) {
    const { emit: a, on: i } = q();
    n.onmessage = ({ data: o }) => a(o.type, o.data);
    function r(o, u, d) {
      const f = [{ type: o, data: u }];
      d && f.push(d), console.debug("Sending encoder event", o, { args: f }), n.postMessage(...f);
    }
    return Object.assign(n, { send: r, on: i });
  }
  s.createEmitter = e;
})(D || (D = {}));
function lt(s, t) {
  let e = s.createMediaStreamDestination();
  const n = e.stream;
  let a = s.createMediaStreamSource(t);
  return a.connect(e), E.onDispose(n, () => {
    E.dispose(t), a.disconnect(), e.disconnect(), a = e = void 0;
  }), n;
}
function dt(s) {
  var n, a, i, X, Y;
  const u = class u extends GainNode {
    constructor(c, l) {
      super(c);
      b(this, i);
      b(this, n);
      b(this, a);
      this.$context = c, this.onGetData = l;
    }
    async init(c) {
      p(this, n) ?? O(this, n, this.context.audioWorklet ? await T(this, i, Y).call(this) : T(this, i, X).call(this)), this.connect(p(this, n)), O(this, a, this.$context.createMediaStreamSource(c)), p(this, a).connect(this), console.debug(`${this.constructor.name}: Using`, p(this, n).constructor.name);
    }
    flush() {
      const c = p(this, a);
      c && (E.dispose(c.mediaStream), c.disconnect(), O(this, a, void 0)), this.disconnect();
    }
  };
  n = new WeakMap(), a = new WeakMap(), i = new WeakSet(), X = function() {
    console.debug("Using legacy processor");
    const c = this.context.createScriptProcessor(4096, 1, 1);
    return c.onaudioprocess = (l) => this.onGetData(l.inputBuffer.getChannelData(0)), c.connect(this.context.destination), c;
  }, Y = async function() {
    const { context: c } = this;
    if (!u.hasWorkletLoaded) {
      const m = await new Promise((S, A) => {
        const x = new Worker(new URL(
          /* @vite-ignore */
          "./assets/processor.worker-1z85LymF.js",
          import.meta.url
        ), { name: "vocal-recorder/worklet", type: "module" });
        x.onmessage = (g) => {
          g.data.url ? (x.terminate(), S(g.data.url)) : A(g.data.error || "Failed to get worklet url");
        };
      });
      console.debug("Loading worklet from", m), await c.audioWorklet.addModule(m), u.hasWorkletLoaded = !0;
    }
    const l = new AudioWorkletNode(c, "pcm-processor");
    return l.port.onmessage = (m) => this.onGetData(m.data), c.addEventListener("statechange", () => {
      c.state === "suspended" && l.port.postMessage("flush");
    }), l;
  }, h(u, "hasWorkletLoaded", !1);
  let t = u;
  class e extends t {
    constructor(c) {
      super(c, (l) => {
        var m;
        return (m = this.encoder) == null ? void 0 : m.encode(l);
      });
      h(this, "encoder");
    }
    async init(c) {
      const l = lt(s, c);
      this.encoder = new D(l), await Promise.all([this.encoder.ready, super.init(l)]);
    }
    async stop() {
      const c = await this.encoder.stop();
      return this.flush(), c;
    }
  }
  return new e(s);
}
function ht(s) {
  const t = new Uint8Array(s.fftSize);
  let e = 0;
  return () => {
    s.getByteTimeDomainData(t);
    let n = 0;
    for (let r = 0; r < t.length; r++) {
      const o = t[r] / 128 - 1;
      n += o * o;
    }
    const a = Math.sqrt(n / t.length);
    e = Math.max(e, a);
    const i = Math.min(1, a / e);
    return { value: a, percentage: i };
  };
}
function ft({
  silenceThreshold: s = 0.01,
  silenceDuration: t = 2e3
} = {}) {
  let e = Date.now(), n = !1;
  return (a) => {
    const i = Date.now();
    let r = n;
    a > s ? (e = i, r = !1) : i - e > t && (r = !0);
    const o = n !== r;
    return n = r, { silent: r, hasChanged: o };
  };
}
var G;
((s) => {
  function t(e, n) {
    const a = J(), { context: i, processor: r } = e, o = i.createAnalyser(), u = ht(o), d = ft(n);
    let f, c = !1;
    function l() {
      f = requestAnimationFrame(l);
      const x = u(), g = d(x.value);
      a.emit("volume", x), g.hasChanged && a.emit("silent", g.silent);
    }
    i.addEventListener("statechange", () => {
      i.state === "running" ? m() : S();
    });
    function m() {
      r.connect(o), l(), c = !0;
    }
    function S() {
      cancelAnimationFrame(f), c && r.disconnect(o), c = !1;
    }
    function A() {
      S(), o.disconnect(), a.all.clear();
    }
    return {
      events: a,
      reset: S,
      dispose: A
    };
  }
  s.create = t;
})(G || (G = {}));
var y;
const v = class v {
  constructor(t = {}) {
    h(this, "events", v.Events.use());
    h(this, "context", j({ latencyHint: "playback", sampleRate: 48e3 }));
    h(this, "processor", dt(this.context));
    b(this, y, {
      current: v.State.Inactive,
      get inactive() {
        return this.current === v.State.Inactive;
      },
      get recording() {
        return this.current === v.State.Recording;
      },
      get paused() {
        return this.current === v.State.Paused;
      }
    });
    this.config = t, this.context.suspend(), this.events.on("*", async (e) => {
      const n = ["start", "resume"].includes(e), a = ["stop", "pause"].includes(e);
      this.config.beep && (n || a) && it({ frequency: n ? 440 : 700 });
    });
  }
  get state() {
    return { ...p(this, y) };
  }
  async init(t = {}) {
    Object.assign(this.config, t);
    const e = t.stream instanceof MediaStream ? t.stream : await E.get(t.stream);
    await this.processor.init(e), this.events.emit("init", { stream: e });
  }
  async start() {
    await this.context.resume(), p(this, y).current = v.State.Recording, this.events.emit("start");
  }
  async pause() {
    await this.context.suspend(), p(this, y).current = v.State.Paused, this.events.emit("pause");
  }
  async resume() {
    await this.context.resume(), p(this, y).current = v.State.Recording, this.events.emit("resume");
  }
  async stop() {
    await this.context.suspend(), p(this, y).current = v.State.Inactive, this.events.emit("stop");
    const t = await this.processor.stop();
    return this.events.emit("result", t), t;
  }
  async dispose() {
    this.processor.flush(), await this.context.close();
  }
};
y = new WeakMap();
let U = v;
((s) => {
  ((t) => {
    t.Inactive = "inactive", t.Recording = "recording", t.Paused = "paused";
  })(s.State || (s.State = {})), ((t) => {
    t.use = J;
  })(s.Events || (s.Events = {}));
})(U || (U = {}));
var $;
((s) => {
  function t(a, i) {
    const r = [];
    for (let o = 0; o < a.length; o += i)
      r.push(a.subarray(o, o + i));
    return r;
  }
  function e(a) {
    const i = new B(), r = new Worker(
      new URL(
        /* @vite-ignore */
        "./assets/worker-BOKI_fsd.js",
        import.meta.url
      ),
      { name: "Vocal Converter Encoder", type: "module" }
    );
    return r.onmessage = (o) => {
      o.data instanceof ArrayBuffer && (i.resolve(o.data), r.terminate());
    }, r.postMessage(a), i;
  }
  async function n(a, {
    sampleRate: i = 48e3,
    onProgress: r = (o) => {
    }
  } = {}) {
    const [o, u] = await Promise.all([
      H(a, {
        sampleRate: i,
        length: i,
        numberOfChannels: 1
      }),
      at(a)
    ]);
    function d(g) {
      return e({ data: g, sampleRate: i, bitRate: u.bitRate, channels: 1 });
    }
    const f = i * 60, l = t(o.getChannelData(0), f).map((g) => t(g, g.length / 4)), m = l.reduce((g, I) => g + I.length, 0);
    let S = 0;
    const A = [];
    console.log("Encoding Chunks", {
      chunkLength: f,
      totalChunkLength: m,
      singleChunkSize: l[0][0].length
    });
    for (const g of l) {
      const I = await Promise.all(
        g.map(
          (K) => d(K).finally(() => r(++S / m))
        )
      );
      A.push(...I);
    }
    return { blob: new Blob(A, { type: "audio/mpeg" }), metadata: u };
  }
  s.toMP3 = n;
})($ || ($ = {}));
export {
  R as AudioBlob,
  P as AudioPeaks,
  U as AudioRecorder,
  G as AudioRecorderAnalyser,
  B as DeferredPromise,
  V as Duration,
  C as RuntimeError,
  E as StreamUtil,
  $ as Transcoder,
  st as blobToBuffer,
  H as getAudioBuffer,
  ct as getAudioBufferPeaks,
  j as getAudioContext,
  ut as getAudioInfo,
  at as getAudioMetadata,
  ot as getAudioPeaks,
  nt as getOfflineAudioContext,
  tt as getWindow,
  it as playBeep,
  et as useAsyncQueue,
  J as useEvents
};
//# sourceMappingURL=index.js.map
